import {
    Phone,
    EnvelopeSimple,
    Microphone,
    Clock,
    Star,
    X,
    WarningCircle,
    Trophy,
} from "@phosphor-icons/react";

export const QUICK_ACTIONS = [
    { status: "Called", label: "Called", Icon: Phone, color: "#002FA7" },
    { status: "Emailed", label: "Emailed", Icon: EnvelopeSimple, color: "#002FA7" },
    { status: "Left Voicemail", label: "VM", Icon: Microphone, color: "#b07000" },
    { status: "Call Back Later", label: "Later", Icon: Clock, color: "#b07000" },
    { status: "Interested", label: "Keen", Icon: Star, color: "#002FA7" },
    { status: "Not Interested", label: "No", Icon: X, color: "#ff3333" },
    { status: "Wrong Contact", label: "Wrong", Icon: WarningCircle, color: "#ff3333" },
    { status: "Invalid Details", label: "Invalid", Icon: WarningCircle, color: "#ff3333" },
    { status: "Claimed Business", label: "Claimed", Icon: Trophy, color: "#000" },
];

export default function QuickActions({
    currentStatus,
    onChange,
    disabled,
    providerId,
    showShortcuts = false,
}) {
    return (
        <div className="flex flex-wrap gap-1" data-testid={`quick-actions-${providerId}`}>
            {QUICK_ACTIONS.map(({ status, label, Icon, color }, i) => {
                const active = currentStatus === status;
                return (
                    <button
                        key={status}
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (!disabled && !active) onChange?.(status);
                        }}
                        disabled={disabled || active}
                        title={`${status}${showShortcuts ? ` — press ${i + 1}` : ""}`}
                        className="inline-flex items-center gap-1 px-2 py-1 mono text-[10px] border transition-colors"
                        style={{
                            borderColor: active ? color : "#e4e4e7",
                            background: active ? color : "#fff",
                            color: active ? "#fff" : color,
                            cursor: disabled ? "not-allowed" : active ? "default" : "pointer",
                        }}
                        data-testid={`action-${status.toLowerCase().replace(/\s+/g, "-")}-${providerId}`}
                    >
                        <Icon size={10} weight="bold" />
                        {label}
                        {showShortcuts && (
                            <span
                                className="opacity-50"
                                style={{ fontSize: 8, marginLeft: 2 }}
                            >
                                {i + 1}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
